import { render, staticRenderFns } from "./vipProportion.vue?vue&type=template&id=3a4c5866&scoped=true"
import script from "./vipProportion.vue?vue&type=script&lang=js"
export * from "./vipProportion.vue?vue&type=script&lang=js"
import style0 from "./vipProportion.vue?vue&type=style&index=0&id=3a4c5866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c5866",
  null
  
)

export default component.exports